/* ==========================================================================
   Holofoil — cart-drawer.js
   AJAX add-to-cart + slide-out cart drawer.
   Only loaded when theme setting cart_type == 'drawer'.
   Falls back to standard cart behaviour on any error.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = null;
  var lastFocused = null;

  function getDrawer() {
    if (!drawer) drawer = document.getElementById('CartDrawer');
    return drawer;
  }

  /* ------------------------------------------------------------------
     Open / close
     ------------------------------------------------------------------ */
  function openDrawer() {
    var el = getDrawer();
    if (!el) return;
    lastFocused = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    var closeBtn = el.querySelector('[data-cart-close-btn]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer() {
    var el = getDrawer();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('drawer-open');
    if (lastFocused) lastFocused.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------
     Refresh drawer contents via the Section Rendering API
     ------------------------------------------------------------------ */
  function refreshDrawer() {
    var el = getDrawer();
    if (!el) return Promise.resolve();
    var root = (window.theme.routes && window.theme.routes.root) || '/';
    var separator = root.indexOf('?') === -1 ? '?' : '&';
    return fetch(root + separator + 'section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('#CartDrawerInner');
        var target = el.querySelector('#CartDrawerInner');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      });
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.textContent = count;
      badge.classList.toggle('is-empty', count === 0);
    });
  }

  function bumpCart() {
    document.querySelectorAll('[data-cart-count]').forEach(function (badge) {
      badge.classList.remove('is-bumping');
      void badge.offsetWidth; // force reflow so the animation can replay
      badge.classList.add('is-bumping');
    });
  }

  function fetchCart() {
    return fetch(window.theme.routes.cart + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) { return response.json(); });
  }

  function setLoading(isLoading) {
    var el = getDrawer();
    if (el) el.classList.toggle('is-loading', isLoading);
  }

  /* ------------------------------------------------------------------
     Add to cart (intercept product forms)
     ------------------------------------------------------------------ */
  function showFormError(form, message) {
    var error = form.querySelector('[data-form-error]');
    if (error) {
      error.textContent = message;
      error.hidden = false;
      setTimeout(function () { error.hidden = true; }, 6000);
    } else {
      window.alert(message);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-type="add-to-cart-form"]');
    if (!form) return;
    if (!window.fetch || window.theme.cartType !== 'drawer') return;

    event.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"], [name="add"]');
    if (submitBtn) {
      if (submitBtn.disabled) return;
      submitBtn.classList.add('is-loading');
      submitBtn.setAttribute('aria-busy', 'true');
    }

    var body = new FormData(form);

    fetch(window.theme.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) {
          showFormError(form, data.description || data.message || window.theme.strings.cartError);
          return null;
        }
        return fetchCart().then(function (cart) {
          updateCartCount(cart.item_count);
          bumpCart();
          return refreshDrawer();
        }).then(openDrawer);
      })
      .catch(function () {
        // Network / parsing problem: fall back to the normal cart page flow.
        window.location.href = window.theme.routes.cart;
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.removeAttribute('aria-busy');
        }
      });
  });

  /* ------------------------------------------------------------------
     Line item changes inside the drawer
     ------------------------------------------------------------------ */
  function changeLine(line, quantity) {
    setLoading(true);
    fetch(window.theme.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawer();
      })
      .catch(function () {
        window.location.href = window.theme.routes.cart;
      })
      .finally(function () { setLoading(false); });
  }

  document.addEventListener('click', function (event) {
    var el = getDrawer();
    if (!el || !el.classList.contains('is-open')) {
      // Header cart icon: open drawer instead of navigating.
      var opener = event.target.closest('[data-cart-open]');
      if (opener && getDrawer()) {
        event.preventDefault();
        refreshDrawer().then(openDrawer);
      }
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    var removeBtn = event.target.closest('[data-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      changeLine(parseInt(removeBtn.getAttribute('data-line'), 10), 0);
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('[data-cart-qty-input]')) return;
    var el = getDrawer();
    if (!el || !el.contains(input)) return;
    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;
    changeLine(parseInt(input.getAttribute('data-line'), 10), quantity);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      var el = getDrawer();
      if (el && el.classList.contains('is-open')) closeDrawer();
    }
  });
})();
